import React from 'react'
import { Avatar, Box, IconButton } from '@mui/material'
import TableData from '../../atoms/table/TableData'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import StatusBtn from '../../atoms/status/StatusBtn'
import KebabMenu from '../../dataGrid/KebabMenu'
import { formatCommonAmount } from '../../../util/formatAmount'

export default function Table({ rows }) {
	const columns = [
		{
			field: 'payment_id',
			headerName: 'Payment Id',
			flex: 1,
			minWidth: 100,
		},
		{
			field: 'party',
			headerName: 'Party',
			flex: 1.5,
			minWidth: 220,
			renderCell: (params) => (
				<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
					<Avatar src={params.row.image} alt={params.value} />
					{params.value}
				</div>
			),
		},
		{
			field: 'amount',
			headerName: 'Amount',
			flex: 1,
			minWidth: 100,
			renderCell: (params) => (
				<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
					{formatCommonAmount(params?.value)}
				</div>
			),
		},
		{ field: 'due_date', headerName: 'Date', flex: 1, minWidth: 100 },
		{
			field: 'status',
			headerName: 'Status',
			flex: 1,
			minWidth: 130,
			renderCell: (params) => {
				const status = params.value
				if (!status) return '-'
				return (
					<StatusBtn
						label={status}
						size="small"
						variant={
							['Completed'].includes(status)
								? 'completed'
								: ['Pending'].includes(status)
									? 'pending'
									: ['In Progress', 'Charged'].includes(
												status
										  )
										? 'inprogress'
										: [
													'Declined',
													'Rejected',
													'Cancelled',
											  ].includes(status)
											? 'error'
											: 'default'
						}
					/>
				)
			},
		},
		{ field: 'invoice', headerName: 'Invoice', flex: 1, minWidth: 100 },
		{
			field: 'menu',
			headerName: '',
			sortable: false,
			filterable: false,
			width: 60,
			align: 'right',
			renderCell: (params) => (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-end',
						width: '100%',
						height: '100%',
					}}
				>
					<IconButton
						data-cy="kebab"
						size="small"
						onClick={(e) => openMenu(e, params.row)}
						sx={{ p: 0.5 }}
					>
						<img src="/images/more.svg" alt="" />
					</IconButton>
				</Box>
			),
		},
	]

	const [menuAnchor, setMenuAnchor] = React.useState(null)
	const [menuRow, setMenuRow] = React.useState(null)

	const openMenu = (e, row) => {
		e.stopPropagation()
		setMenuAnchor(e.currentTarget)
		setMenuRow(row)
	}

	const closeMenu = () => {
		setMenuAnchor(null)
		setMenuRow(null)
	}

	return (
		<div style={{ gridTemplateColumns: '1fr 1fr' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					// height: 'calc(100vh - 420px)',
					// height: '100%',
					// minHeight: 200,
					'@media (max-width: 900px)': {
						// height: 'calc(100vh - 390px)',
					},
				}}
			>
				<Box sx={{ flex: 1, minHeight: 0 }}>
					<TableData
						rows={rows}
						columns={columns}
						sx={{
							height: 'calc(100dvh - 200px)',
							'@media (max-width: 768px)': {
								height: 'calc(100dvh - 260px)',
							},
						}}
						onRowClick={({ row }) => row.viewDetails()}
					/>
				</Box>

				<KebabMenu
					anchorEl={menuAnchor}
					open={Boolean(menuAnchor)}
					onClose={closeMenu}
					items={[
						{
							key: 'send_reminder',
							label: 'Send Reminder',
							icon: (
								<img
									src="/images/alarm.svg"
									alt="send_reminder"
								/>
							),
							onClick: () =>
								console.log('Send Reminder', menuRow),
						},
						{
							key: 'download_invoice',
							label: 'Download Invoice',
							icon: (
								<img
									src="/images/Invoice.svg"
									alt="download_invoice"
								/>
							),
							onClick: () =>
								console.log('Download Invoice', menuRow),
						},
						{
							key: 'edit',
							label: 'Edit',
							icon: (
								<img src="/images/edit-icon.svg" alt="edit" />
							),
							onClick: () => console.log('Edit', menuRow),
						},
						{
							key: 'delete',
							label: 'Delete',
							icon: (
								<img
									src="/images/DeleteModal.svg"
									alt="delete"
								/>
							),
							onClick: () => console.log('Delete', menuRow),
							color: 'error.main',
						},
					]}
				/>
			</Box>
		</div>
	)
}
